import { Flex, Text, View, Link } from '@smarterservices/smarter-ui';

/**
 * Fixed Footer component that stays at the bottom of the viewport
 */
const Footer = () => {
  return (
    <View
      as="footer"
      background="primary"
      padding="small 0"
    >
      <Flex
        direction="row"
        width="100%"
      >
        <Flex.Item alignItems="start" shouldShrink shouldGrow margin="0 0 0 small">
          <Text color="primary" size="small">
            &copy; {new Date().getFullYear()} SmarterServices, LLC. All rights reserved.
          </Text>
        </Flex.Item>
        <Flex.Item alignItems="end" margin="0 small 0 0">
          <Text color="primary" size="small">
            <Link href="https://www.smarterservices.com/privacy-policy" target="_blank" isWithinText={false}>Privacy Policy</Link> 
            <Text color="primary" size="small"> | </Text>
            <Link href="https://www.smarterservices.com/terms-of-use" target="_blank" isWithinText={false}>Terms of Use</Link>
          </Text>
        </Flex.Item>
      </Flex>
    </View>
  );
};

export default Footer;
